﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import SelfServicePage from "./Component";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default SelfServicePage;
export * from "./Styles";
export * from "./Component";
